import { render, staticRenderFns } from "./hawa.component.vue?vue&type=template&id=6e836bbe&"
import script from "./hawa.component.vue?vue&type=script&lang=ts&"
export * from "./hawa.component.vue?vue&type=script&lang=ts&"
import style0 from "./hawa.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports